import { ExclamationTriangleIcon, FlagIcon } from "@heroicons/react/24/outline";

import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";

import { useQaScanState } from "@components/QaReview/hooks/useQaScanState";

/**
 * Checkpoint's mark, shared by the switch and the review bar so both say the same thing: a flag, or a warning
 * once Quality Review has failed. Callers show their own spinner beside it while the scan checks.
 */
export const CheckpointMark: React.FC<{ className?: string }> = ({ className }) => {
  const { isFailed } = useQaScanState();
  return isFailed ? (
    <ExclamationTriangleIcon aria-hidden className={cn(className, "text-icon-error")} />
  ) : (
    <FlagIcon aria-hidden className={className} />
  );
};
